/**
 * Base URL for API calls.
 *
 * - `VITE_API_URL`: explicit override (staging / production).
 * - Development (Vite): implicit empty string → same origin; Vite proxies `/api` to the backend.
 *   Evită `VITE_API_URL=http://127.0.0.1:8000` cu pagina pe `http://localhost:3000`:
 *   cookie-urile auth (SameSite=Lax) nu se trimit cross-site între hosturi diferite.
 *   Pentru apel direct la API în dev: `VITE_DEV_USE_DIRECT_API=true` + `VITE_API_URL=...`.
 * - `staging.aifoiparcurs.ro` → mereu `https://app.staging.aifoiparcurs.ro` înainte de
 *   `VITE_API_URL`: dacă pe Railway e setat URL-ul API de producție, preflight-ul CORS
 *   către prod returnează 400 și browserul raportează „fără răspuns” la login.
 * - Alte hosturi `*.aifoiparcurs.ro` fără `VITE_API_URL`: `https://app.aifoiparcurs.ro`.
 * - Altfel fallback legacy `http://<host>:8000`.
 */
export function getApiBaseUrl(): string {
  if (typeof window !== "undefined") {
    const h = window.location.hostname;
    const isStagingHost = h === "staging.aifoiparcurs.ro";
    if (isStagingHost) {
      return "https://app.staging.aifoiparcurs.ro";
    }
  }

  const devUseDirectApi =
    import.meta.env.DEV &&
    import.meta.env.VITE_DEV_USE_DIRECT_API === "true";
  if (import.meta.env.DEV && !devUseDirectApi) {
    return "";
  }

  const explicit = (import.meta.env.VITE_API_URL as string | undefined)?.trim();
  if (explicit) {
    return explicit.replace(/\/$/, "");
  }
  if (import.meta.env.DEV) {
    return "";
  }
  if (typeof window === "undefined") {
    return "http://127.0.0.1:8000";
  }
  const h = window.location.hostname;
  const isProjectHost = import.meta.env.PROD && h.endsWith("aifoiparcurs.ro");
  if (isProjectHost) {
    return "https://app.aifoiparcurs.ro";
  }
  if (import.meta.env.PROD) {
    console.warn(
      "[API] Lipsește VITE_API_URL. Setează URL-ul HTTPS al API în variabilele de build (Railway) și redeploy.",
    );
  }
  const host = h === "localhost" || h === "::1" ? "127.0.0.1" : h;
  return `http://${host}:8000`;
}
